import {Box} from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import {Outlet, useLocation} from 'react-router-dom';
import {Helmet} from 'react-helmet-async';
import React from 'react';

import {useHostName} from 'presentation/hooks';
import {MainFooter} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages/private';
import {SelectionFlowEnum} from 'presentation/constants';
import {SelectionHeader, SelectionSideContent} from './components';

export * from './constants';
export * from './pages';

export function SelectionFlow() {
	const {isTablet} = useMediaQueries();
	const {dataHostNameState} = useHostName();
	const location = useLocation();

	const showCustomMargin =
		location.pathname === SelectionFlowEnum.PLAN_SELECTION ||
		location.pathname === SelectionFlowEnum.BENEFICIARY_SELECTION;

	const {productName} = dataHostNameState;

	return (
		<Grid2 container minHeight="100vh">
			<Helmet>
				<title>{`${productName}`}</title>
			</Helmet>
			{!isTablet ? (
				<Grid2 size={{lg: 3.5, md: 4.4}} display="flex">
					<SelectionSideContent />
				</Grid2>
			) : null}
			<Grid2 size={{xs: 12, lg: 8.5, md: 7.6}} display="flex" flexDirection="column">
				<SelectionHeader />
				<Outlet />
				<Box sx={{mt: 'auto'}}>
					<MainFooter customMarginBottom={showCustomMargin ? '32px' : undefined} />
				</Box>
			</Grid2>
		</Grid2>
	);
}
